import { MapContainer, TileLayer } from "react-leaflet";
import { CRS } from "leaflet";
import RasterCoords from "leaflet-rastercoords";

const Home = () => {
  const initiateMap = (map) => {
    const img = [14200, 14200];
    var rc = new RasterCoords(map, img);
    // set max zoom Level (might be `x` if gdal2tiles was called with `-z 0-x` option)
    map.setMaxZoom(rc.zoomLevel());
    // all coordinates need to be unprojected using the `unproject` method
    // set the view in the lower right edge of the image
    map.setView(rc.unproject([img[0], img[1]]), 2);

    // // set markers on click events in the map
    // map.on('click', function (event) {
    //   // any position in leaflet needs to be projected to obtain the image coordinates
    //   var coords = rc.project(event.latlng)
    //   var marker = L.marker(rc.unproject(coords))
    //     .addTo(map)
    //   marker.bindPopup('[' + Math.floor(coords.x) + ',' + Math.floor(coords.y) + ']')
    //     .openPopup()
    // })
  };

  return (
    <MapContainer
      // center={[0, 0]}
      crs={CRS.Simple}
      zoom={3}
      minZoom={3}
      maxZoom={8}
      scrollWheelZoom={true}
      attributionControl={false}
      zoomControl={false}
      whenCreated={initiateMap}
    >
      <TileLayer url="https://cosmoburn.github.io/tiles/{z}/{x}/{y}.png" />
    </MapContainer>
  );
};

export default Home;
